import { mapGetters } from "vuex";

export default {
  name: "channel-options",
  props: {
    opportunity: { type: Object },
    selectedChannel: { type: String },
    disableInputs: { type: Boolean },
    resellerChannelOptions: { type: Object },
  },
  computed: {
    ...mapGetters({
      associatedSeller: 'associatedSeller',
    }),
    salesChannelLabel(){
      return this.$store.state.admin?.associated_seller ? "Venda Associada" : "Venda Direta"

    } 
  },
  async mounted(){
    this.$props.selectedChannel = this.associatedSeller ? 'associated' : 'TALLOS'
  },
  watch: {
    selectedChannel(value) {
      this.$emit("update-channel", value);
    },
  },
};
